export default "https://cdn-static.gokick.com/assets/713f881f9452b025a6ed3fcaec249d98fea8bb41/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";